const PROVIDER_LABELS = { linkedin: 'LinkedIn', google_oauth2: 'Google' };

export default function oauthProviderDisplayName(provider) {
  return PROVIDER_LABELS[provider] || provider;
}
